/** Path of the Trust section. */
const TRUST_SECTION = '/trust';

/** Matches `/trust` and `/trust/...` only, unlike a bare `startsWith('/trust')` which would also match `/trust-portal` or `/trusted-devices`. Suppresses the auto-pinned Tasks panel in favour of Tambi when true. */
export function isTrustSectionPath(pathname: string): boolean {
  return pathname === TRUST_SECTION || pathname.startsWith(`${TRUST_SECTION}/`);
}
